import { render, staticRenderFns } from "./VideoScreen.vue?vue&type=template&id=6083fc1c&scoped=true&"
import script from "./VideoScreen.vue?vue&type=script&lang=ts&"
export * from "./VideoScreen.vue?vue&type=script&lang=ts&"
import style0 from "./VideoScreen.vue?vue&type=style&index=0&id=6083fc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6083fc1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
